var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 164,
    viewBox: "0 0 306 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 123H10C4.47715 123 0 118.523 0 113V51.5C0 45.9772 4.47715 41.5 10 41.5H15C26.0457 41.5 35 32.5457 35 21.5V10C35 4.47715 39.4771 0 45 0H209C214.523 0 219 4.47715 219 10V21.5C219 32.5457 227.954 41.5 239 41.5H251.297C256.801 41.5 261.271 45.9487 261.297 51.4533L261.426 79.0748C261.467 87.882 268.618 95 277.425 95H295.427C300.978 95 305.467 99.5214 305.427 105.072L305.094 151.094C305.042 158.237 299.237 164 292.094 164H111C105.477 164 101 159.523 101 154V143C101 131.954 92.0457 123 81 123Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shoppingCart.133f4c47c5397c4d90b2c512f30585f1.svg";
export { ForwardRef as ReactComponent };